import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingTopImageLarge: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 7H0V0h16zM0 11.5h16V9H0zM0 16h12v-2.5H0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingTopImageLarge
